<template>
    <v-container id="resource--embed">
        <v-row column justify-center align-center no-gutters>
            <v-col cols="12">
                <div v-if="cadUrl" style="margin: auto; text-align: center">
                    <v-btn
                        color="primary"
                        class="mb-8"
                        target="_self"
                        :href="cadUrl"
                        ><TranslatableStringComponent
                            :tstring="{ string: 'downloadCadFile' }"
                        />
                        <span
                            v-if="page.cadDrawingType && page.cadDrawingType[0]"
                        >
                            ({{ page.cadDrawingType[0] }})</span
                        ></v-btn
                    >
                </div>
                <div v-if="pdfUrl" style="margin: auto" class="text-center">
                    <!-- <iframe
                        src="/testing.html"
                        :height="iHeight"
                        width="100%"
                        frameborder="0"
                    ></iframe> -->
                    <iframe
                        v-if="this.$vuetify.breakpoint.mdAndUp"
                        :src="`${pdfUrl}?embedded=true`"
                        :height="iHeight"
                        width="100%"
                        frameborder="0"
                    ></iframe>
                    <v-btn
                        v-else
                        class="mb-4"
                        :href="pdfUrl"
                        target="_blank"
                        color="warning"
                        right
                    >
                        <TranslatableStringComponent
                            :tstring="{ string: 'viewResource' }"
                        />
                        <fa
                            :icon="['fal', 'external-link']"
                            class="fa-sm ml-2"
                            style="color: #fff"
                        />
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'Resource',
    components: {
        TranslatableStringComponent,
    },
    props: {
        page: {
            type: Object,
            default: null,
        },
        template: {
            type: String,
            default: '',
        },
    },
    computed: {
        iHeight() {
            return this.$vuetify.breakpoint.smAndDown ? 500 : 1000
        },
        cadUrl() {
            return this.page?.assetCad
                ? `${process.env.ASSET_HOSTNAME}${this.page?.assetCad?.originalFilename}`
                : ''
        },
        pdfUrl() {
            const enPdf = this.page?.sanityPdf
                ? `${process.env.ASSET_HOSTNAME}${this.page?.sanityPdf.selectedFile.asset.originalFilename}`
                : ''
            const esPdf = this.page?.sanityPdfEs
                ? `${process.env.ASSET_HOSTNAME}${this.page?.sanityPdfEs?.selectedFile.asset.originalFilename}`
                : ''
            return this.$i18n.locale === 'es' ? esPdf || enPdf : enPdf
        },
    },
}
</script>
